import styled from "styled-components";
import materialUI from "material-UI";
import colors from "constants/color";

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  width: 400px;
  background: #ffffff;
  border-radius: 8px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
`;

export const Header = styled.div``;

export const Body = styled.div``;

export const TextTitle = styled.p`
  font-family: Inter;
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  text-align: left;
  color: #101828;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`;

export const Button: any = styled.button`
  display: flex;
  width: ${(props: any) => props.width || "100%"};
  height: ${(props: any) => props.height || "100%"};
  border: ${(props: any) => props.border || "none"};
  align-items: center;
  justify-content: center;
  gap: 12px;
  height: 44px;
  border-radius: 8px;
  background-color: ${(props: any) => props.color || "#2d5bff"};
  :hover {
    cursor: pointer;
  }
  :disabled {
    cursor: not-allowed;
  }
`;

export const TextButton = styled.p`
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  color: ${(props: any) => props.color || "#2d5bff"};
`;

export const MultLineField = styled.div`
  position: relative;
  margin-top: 8px;
  width: 100%;
`;

export const LabelText = styled.span`
  display: flex;
  flex-direction: row;
  font-size: 14px;
  line-height: 150%;
  color: #333333;
  font-family: Inter-Medium;
  margin-bottom: 5px;

  p {
    color: red;
    margin-left: 4px;
  }
`;

export const TextField = styled(materialUI.TextField)`
  margin-top: 2px;
  label {
    display: none;
  }
  legend {
    span {
      display: none;
    }
  }
  .MuiInputBase-root {
    border-radius: 8px;
  }
  .Mui-focused {
    fieldset {
      border-color: ${colors.primary} !important;
    }
  }
  .Mui-error {
    fieldset {
      border-color: #d32f2f !important;
    }
  }
  textarea {
    position: relative;
    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb {
      background: ${colors.LigthGrey};
    }
  }
`;

export const ErrorText = styled.span`
  display: block;
  margin-top: 4px;
  font-family: Inter;
  font-size: 12px;
  line-height: 16px;
  color: #d32f2f;
`;

export const CountText = styled.span`
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: ${colors.grey1};
  background: ${colors.White};
  position: absolute;
  right: 20px;
  bottom: 10px;
`;

export const SpaceY: any = styled.div`
  height: ${(props: any) => props.space}px !important;
`;
